import actionTypes from "../actionTypes";
import superagentPromise from "superagent-promise";
import _superagent from "superagent";
import { restaurantCapabilitiesApiRoot } from "../../config.{env}.json";

// Internal only, for readability
const capabilitiesAreLoading = () => ({
    type: actionTypes.RESTAURANT_CAPABILITIES_LOADING,
});

const allCapabilitiesHaveLoaded = (capabilities) => ({
    type: actionTypes.RESTAURANT_ALL_CAPABILITIES_LOADED,
    payload: capabilities,
});

const flagsHaveLoaded = (flags) => ({
    type: actionTypes.RESTAURANT_FLAGS_LOADED,
    payload: flags,
});

const capabilitiesHaveLoaded = () => ({
    type: actionTypes.RESTAURANT_CAPABILITIES_LOADED,
});

const capabilitiesLoadHasError = () => ({
    type: actionTypes.RESTAURANT_CAPABILITIES_ERROR,
});

export function loadCapabilities() {
    return (dispatch, getState) => {
        const state = getState();

        const token = state.oidc.user.access_token;
        const requester = state.oidc.user.profile.upn;
        const tenant = state.tenant.currentTenant;
        const restaurantId = state.restaurant.restaurantId;

        dispatch(capabilitiesAreLoading());

        const userApi = api(token, requester);

        const requests = [
            userApi
                .getAll()
                .then((capabilities) =>
                    dispatch(allCapabilitiesHaveLoaded(capabilities))
                ),

            userApi
                .get(tenant, restaurantId)
                .then((flags) => dispatch(flagsHaveLoaded(flags))),
        ];

        Promise.all(requests)
            .then(() => dispatch(capabilitiesHaveLoaded()))
            .catch(() => dispatch(capabilitiesLoadHasError()));
    };
}

export function saveCapabilities() {
    return (dispatch, getState) => {
        const token = getState().oidc.user.access_token;
        const requester = getState().oidc.user.profile.upn;
        const tenant = getState().tenant.currentTenant;
        const restaurantId = getState().restaurant.restaurantId;
        const currentFlags = getState().capabilities.currentFlags;
        const cleanCurrentFlags = {};

        const allowedFlags = getState()
            .capabilities.capabilities.filter((c) => !c.SystemOnly)
            .map((c) => c.Id);

        for (let flag of allowedFlags) {
            cleanCurrentFlags[flag] = currentFlags[flag];
        }

        console.warn(cleanCurrentFlags);
        dispatch({ type: actionTypes.RESTAURANT_CAPABILITIES_SAVING });

        const userApi = api(token, requester);

        userApi
            .patch(tenant, restaurantId, cleanCurrentFlags)
            .then((flags) =>
                dispatch({
                    type: actionTypes.RESTAURANT_FLAGS_LOADED,
                    payload: flags,
                })
            )
            .then(() =>
                dispatch({ type: actionTypes.RESTAURANT_CAPABILITIES_SAVED })
            )
            .catch(() => {
                dispatch({
                    type: actionTypes.RESTAURANT_CAPABILITIES_SAVE_ERROR,
                });
            });
    };
}

export function setFlag(id, value) {
    return (dispatch) => {
        dispatch({
            type: actionTypes.RESTAURANT_CAPABILITIES_SET_FLAG,
            payload: {
                id,
                value,
            },
        });
    };
}

export function restFlags() {
    return (dispatch) => {
        dispatch({
            type: actionTypes.RESTAURANT_CAPABILITIES_RESET_FLAGS,
        });
    };
}

//These last two i dont like, we need to thnk about it

export function clearErrors() {
    return (dispatch) => {
        dispatch({
            type: actionTypes.RESTAURANT_CAPABILITIES_CLEAR_ERRORS,
        });
    };
}

export function clearSave() {
    return (dispatch) => {
        dispatch({
            type: actionTypes.RESTAURANT_CAPABILITIES_SAVED_CLEAR,
        });
    };
}

//Api Client here
const superagent = superagentPromise(_superagent, global.Promise);

const responseBody = (res) => res.body;
const api = (token, requester) => {
    return {
        getAll: () =>
            superagent
                .get(`${restaurantCapabilitiesApiRoot}/capabilities`)
                .set("Authorization", `Bearer ${token}`)
                .then(responseBody),

        get: (tenant, restId) =>
            superagent
                .get(
                    `${restaurantCapabilitiesApiRoot}/${tenant}/restaurants/${restId}`
                )
                .set("Authorization", `Bearer ${token}`)
                .then(responseBody),

        patch: (tenant, restId, values) =>
            superagent
                .patch(
                    `${restaurantCapabilitiesApiRoot}/${tenant}/restaurants/${restId}`,
                    values
                )
                .set("Authorization", `Bearer ${token}`)
                .set("X-JE-Requester", requester)
                .then(responseBody),
    };
};



// WEBPACK FOOTER //
// /src/store/actions/capabilities.js